export function getItemByField(filedName, fieldValue, items) {
  if (items === undefined) {
    return undefined;
  }
  for (let i = 0; i < items.length; i++) {
    if (items[i][filedName] == fieldValue) {
      return items[i];
    }
  }
  return undefined;
}

export function getItemById(id, items) {
  if (items === undefined) {
    return undefined;
  }
  for (let i = 0; i < items.length; i++) {
    if (items[i].id == id) {
      return items[i];
    }
  }
  return undefined;
}

export function getItemByName(name, items) {
  if (items === undefined) {
    return undefined;
  }
  for (let i = 0; i < items.length; i++) {
    if (items[i].name == name) {
      return items[i];
    }
  }
  return undefined;
}
